import styled from "styled-components";

export const AssetDetailWrapper = styled.div`
  display: grid;
  .asset-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5rem;
    margin: 2rem 4rem;
    color: #fff;
    .left-content {
      margin: 0 1rem;
      
      
      .asset-preview {
        display: grid;
        justify-content: center;
        .asset-img {
          display: grid;
          grid-template-columns: minmax(100px, 1fr);
          div {
            width: 100% !important;
            height: 100% !important;
            canvas {
              width: 100% !important;
              height: 100% !important;
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
      }

      .asset-price {
        display: grid;
        grid-template-columns: 1fr 1fr;
        span {
          text-transform: uppercase;
          font-size: 13px;
          line-height: 15px;
         
          color: #d2d3d4;
          text-align: left;
          letter-spacing: 1.3px;
        }
        .price {
          justify-self: flex-end;
          div {
            span {
              font-size: 18px;
              line-height: 22px;
             
              color: #ffbf36;
              text-align: left;
            }
          }
          span {
            font-size: 14px;
            line-height: 22px;
           
            color: #a0a4a7;
            text-align: right;
            float: right;
          }
        }
      }

      .asset-user {
        display: grid;
        grid-template-columns: auto auto;
        align-items: center;
        a {
          color: #00adef;
          font-size: 25px;
        }
        span {
          justify-self: flex-end;
          font-weight: 400;
        }
      }

      .asset-processes {
        display: grid;
        grid-template-columns: 1fr 2fr 3fr;
        gap: 1rem;
        button {
          padding: .5rem;
          border-radius: 20px;
          color:#fff;
        }
        .addcart-btn {
          background-color: transparent;
          border: 1px solid #fff;
        }
        .buy-btn {
          background-color: #0084ff;
          border: 1px solid #0084ff;
        }
      }
    }

    .right-content {
      display: grid;
      gap: 1rem;
      .asset-main-info {
        margin: 0 1rem;
        display: grid;
        grid-template-rows: auto;
        gap: 1rem;
        .token-info {
          display: grid;
          grid-template-columns: repeat(3, auto);
          span {
            display: grid;
            grid-template-columns: 15% auto;
            align-items: center;
            svg {
              color: #03cd6e;
            }
          }
        }
      }

      .asset-about {
        margin: 0 1rem;
        display: grid;
        gap: 1rem;
        .about-box {
          gap: 2rem;
          justify-content: flex-start;
          align-items: flex-start;
          border: solid;
          border-color: #2f3740;
          border-radius: 10px;
          border-width: 1px;
          padding: 20px 25px;
          background-color: #20252c;
          box-shadow: 0 0 10px rgb(0 0 0 / 20%);
          .about-first-line {
            display: grid;
            grid-template-columns: 150px auto;
          }
          .about-type {
            display: grid;
            gap: .5rem;
            p {
              display: grid;
              grid-template-columns: repeat(2,auto);
              margin: 5px 5px 5px 0;
              padding: 5px 0;
            }
          }
          .about-biomes {
            display: grid;
            gap: .5rem;
            p {
              margin: 5px 5px 5px 0;
              padding: 5px 0;
            }
          }
          .about-tags {
            display: grid;
            gap: .5rem;
            .tags {
              display: grid;
              grid-template-columns: repeat(3, auto);
              p {
                display: grid;
                grid-template-columns: repeat(2, auto);
                text-transform: capitalize;
                margin: 5px 5px 5px 0;
                background-color: #2f3740;
                padding: 5px 15px;
                border-radius: 30px;
              }
            }
          }
        }
      }

      .asset-attributes {
        margin: 0 1rem;
        display: grid;
        gap: 1rem;
        .attributes-box {
          display: grid;
          grid-template-columns: auto;
          gap: 2rem;
          justify-content: flex-start;
          align-items: flex-start;
          border: solid;
          border-color: #2f3740;
          border-radius: 10px;
          border-width: 1px;
          padding: 20px 25px;
          width: 100%;
          background-color: #20252c;
          box-shadow: 0 0 10px rgb(0 0 0 / 20%);
          border-right: 1px solid #2f3740;
          .attributes {
            display: grid;
            grid-template-columns: repeat(5,1fr);
            grid-template-rows: 1fr;
            gap: 1rem;
            text-align: center;
            div {
              display: grid;
              gap: .5rem;
              span {
                display: grid;
                grid-template-columns: auto auto;
                align-items: center;
                font-size: 19px;
                line-height: 17px;
                
                color: #fff;
                text-align: left;
                margin-left: 10px;
                white-space: nowrap;
                img {
                  max-height: 100%;
                  max-width: 80%;
                }
              }
            }
          }
        }
      }

      .asset-description {
        margin: 0 1rem;
        display: grid;
        gap: 1rem;
        span {
          color: #bdc0c2;
        }
        .share span {
          font-size: x-large;
          display: grid;
          grid-template-columns: 20% 10% 10%;
        }
      }

      .asset-creation {
        margin: 0 1rem;
        display: grid;
        gap: .5rem;
        span {
          line-height: 18px;
          color: #a0a4a7;
          text-align: left;
        }
        ul {
          list-style: none;
          li {
            margin: .5rem 0;
            span {
              margin-left: .5rem;
            }
          }
        }
      }
    }
  }

  @media all and (max-width: 575px) {
    .asset-container {
      margin: 0;
      grid-template-columns: 1fr;
      .token-info {
        span {
          grid-template-columns: 1fr !important;
        }
      }
      .asset-description {
        .share span {
          grid-template-columns: 60% auto auto !important;
        }
      }
      .asset-attributes {
        .attributes-box {
          grid-template-columns: repeat(1, auto) !important;
        }
      }
      .asset-about {
        .about-box {
          grid-template-columns: repeat(1,auto) !important;
          .about-tags {
            .tags {
              grid-template-columns: repeat(2, auto) !important;
            }
          }
        }
      }
    }
  }
  @media all and (max-width: 1160px) {
    .asset-container {
      grid-template-columns: 1fr;
    }
  }
`;